// Touch events
(() => {
  let classNames = [];
  if (
    navigator.maxTouchPoints === undefined ||
    navigator.maxTouchPoints === 0
  ) {
    classNames.push('no-touch');
  }

  // iOS Device Detection
  if (window.navigator.userAgent.match(/iPad|iPhone|iPod/i)) {
    classNames.push('ios');
  }

  // Check platform
  if (navigator.platform.indexOf('Mac') > -1) {
    classNames.push('mac');
  }
  if (navigator.platform.indexOf('Win') > -1) {
    classNames.push('win');
  }
  if (navigator.platform.indexOf('Linux') > -1) {
    classNames.push('linux');
  }

  for (let i in classNames) {
    document.documentElement.classList.add(classNames[i]);
  }
})();
